import React, { useState, ChangeEvent } from 'react';
import { useStyles } from '../../style';
import { Box, Grid, IconButton, InputAdornment, TextField, Typography, Modal } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import KenButton from '../../../../GlobalComponents/KenButton';
import { postProfileCertificateDetails } from '../../../../Utils/apiService';
import dayjs, { Dayjs } from 'dayjs';
import { enqueueSnackbar } from 'notistack';
const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid white',
  boxShadow: 24,
  borderRadius: 2,
  width: { lg: '40vw', xl: '40vw' },
  p: 4,
};
const AddCertificateData = (props: any) => {
  const { userData, handleClose, value } = props;
  const [issueDate, setIssueDate] = useState<Dayjs | null>(dayjs(value?.Issue_Date__c ? value?.Issue_Date__c : dayjs()));
  const [expirationDate, setExpirationDate] = useState<Dayjs | null>(dayjs(value?.Expiration_Date__c ? value?.Expiration_Date__c : dayjs()));
  const [error, setError] = useState<string | null>(null);
  console.log(value, "jgfchlkk");

  const [formData, setFormData] = useState<any>({
    name: value?.Name ? value?.Name : '',
    contactId: userData?.applicantId,
    issueDate: value?.Issue_Date__c ? value?.Issue_Date__c : '',
    issuingOrganization: value?.Issuing_Organization__r?.Name ? value?.Issuing_Organization__r?.Name : '',
    certificateId: props?.value?.Id,
    credentialId: value?.Credential_Id__c ? value?.Credential_Id__c : '',
    credentialURL: value?.Certificate_URL__c ? value?.Certificate_URL__c : '',
    expirationDate: value?.Expiration_Date__c ? value?.Expiration_Date__c : '',
    certificateUrl: value?.Uploaded_Certificate_URL__c
  });
  const classes = useStyles();
  const [errors, setErrors] = useState<{ name?: string; issuingOrganization?: string }>({});
  const handleChangeField = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors: { [x: string]: any; }) => ({ ...prevErrors, [name]: value ? '' : prevErrors[name] }));
  };
  const handleChangeIssueDate = (newValue: Dayjs | null) => {
    setIssueDate(newValue);
    if (expirationDate && newValue && expirationDate.isBefore(newValue)) {
      setError('Expiration Date cannot be earlier than Issue Date.');
    } else {
      setError(null);
    }
  };

  const handleChangeExpirationDate = (newValue: Dayjs | null) => {
    setExpirationDate(newValue);
    if (issueDate && newValue && newValue.isBefore(issueDate)) {
      setError('Expiration Date cannot be earlier than Issue Date.');
    } else {
      setError(null);
    }
  };
  const formatDate = (value: Dayjs | null): string => {
    if (value === null) {
      return '';
    }
    return value.format('YYYY-MM-DD');
  };
  const validateForm = () => {
    let newErrors: { name?: string; issuingOrganization?: string } = {};
    if (!formData.name.trim()) newErrors.name = 'Please fill mandatory field *';
    if (!formData.issuingOrganization.trim()) newErrors.issuingOrganization = 'Please fill mandatory field *';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const [fileName, setFileName] = useState<string>('');
  const [base64Image, setBase64Image] = useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Check file size (5MB limit)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        enqueueSnackbar({ message: 'File size should not exceed 5MB', variant: 'error', autoHideDuration: 1000 });
        return;
      }

      // Check file type
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        enqueueSnackbar({ message: 'We accept only PDF, JPG, JPEG, and PNG files', variant: 'error', autoHideDuration: 1000 });
        return;
      }

      setFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const splitData = base64String.split(',');
        setBase64Image(splitData[1]);
        console.log('Base64 File: ', base64String);
      };
      reader.readAsDataURL(file);
    }
  };
  const postCertificateDetails = () => {
    if (!validateForm()) return enqueueSnackbar({ message: 'Please fill mandatory field', variant: 'error', autoHideDuration: 1000 });;
    const dateValue: Dayjs | null = dayjs(issueDate);
    const formattedDate = formatDate(dateValue);
    const payload: any = {
      ...formData,
      issueDate: formattedDate,
      expirationDate: formatDate(dayjs(expirationDate)),
      fileBlob: base64Image,
      fileName: fileName,
    };
    postProfileCertificateDetails(payload)
      .then((res) => {
        if (res?.success) {
          props.setPreferStatus(true);
          enqueueSnackbar({
            message: 'Certificate Details Saved Sucessfully',
            variant: 'success',
            autoHideDuration: 1000,
          });
          props.handleClose();
        } else {
          enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        }
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something went wrong', variant: 'error', autoHideDuration: 1000 });
        console.error(err);
      });
  };

  const [openViewModal, setOpenViewModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  const handleOpenViewModal = () => setOpenViewModal(true);
  const handleCloseViewModal = () => setOpenViewModal(false);

  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => setOpenEditModal(false);

  return (
    <div>
      <Box sx={style}>
        <Typography
          sx={{
            textAlign: 'left',
            fontWeight: 500,
            fontSize: '13px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              fontSize: '12px !important',
            },
          }}
        >
          {props.data == 'edit' ? 'Edit Certificate' : 'Add Certificate'}
        </Typography>
        <hr style={{ border: '1px solid #E6E6E8' }} />
        <Grid container spacing={2} sx={{ marginTop: '-40px' }}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 3,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Certification Name
            </Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter certification name"
              name="name"
              value={formData.name}
              onChange={handleChangeField}
              variant="outlined"
              fullWidth
              error={!!errors.name}
              helperText={errors.name}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 3,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Issuing Organization
            </Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter Issuing organization"
              name="issuingOrganization"
              value={formData.issuingOrganization}
              onChange={handleChangeField}
              variant="outlined"
              error={!!errors.issuingOrganization}
              helperText={errors.issuingOrganization}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 1,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Issue Date
            </Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  value={issueDate}
                  onChange={handleChangeIssueDate}
                  maxDate={dayjs()}
                  format="DD/MM/YYYY"
                  slots={{
                    textField: (params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: '36px',
                            borderRadius: '6px',
                            fontSize: '12px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                          },
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 1,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Expiration Date
            </Typography>
            <Box sx={{ mt: 1.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  value={expirationDate}
                  onChange={handleChangeExpirationDate}
                  format="DD/MM/YYYY"
                  slots={{
                    textField: (params) => (
                      <TextField
                        {...params}
                        size="small"
                        fullWidth
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            height: '36px',
                            borderRadius: '6px',
                            fontSize: '12px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                          },
                        }}
                      />
                    ),
                  }}
                />
              </LocalizationProvider>
              {error && (
                <Typography sx={{ color: 'red', mt: 1, fontSize: '10px' }}>
                  {error}
                </Typography>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 2,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Credential ID
            </Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter Credential ID"
              name="credentialId"
              value={formData.credentialId}
              onChange={handleChangeField}
              variant="outlined"
              error={!!errors.issuingOrganization}
              helperText={errors.issuingOrganization}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              sx={{
                fontWeight: 500,
                mt: 2,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Credential URL
            </Typography>
            <TextField
              sx={{
                mt: 1.5,
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                  borderRadius: '6px',
                  fontSize: '12px',
                },
                '& .MuiOutlinedInput-input': {
                  fontSize: '12px',
                },
              }}
              size="small"
              id="outlined-basic"
              placeholder="Enter Credential URL"
              name="credentialURL"
              value={formData.credentialURL}
              onChange={handleChangeField}
              variant="outlined"
              error={!!errors.issuingOrganization}
              helperText={errors.issuingOrganization}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <center><Typography>(or)</Typography></center>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <>
              {formData?.certificateUrl ?
                <>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '12px',
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        fontSize: '11px !important',
                      },
                    }}
                  >
                    Uploaded Certificate
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, mt: 1.5 }}>
                    <KenButton
                      variant="contained"
                      onClick={handleOpenViewModal}
                      sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        borderRadius: '6px',
                        height: '36px',
                      }}
                    >
                      View Certificate
                    </KenButton>
                    <KenButton
                      variant="outlined"
                      onClick={handleOpenEditModal}
                      sx={{
                        fontSize: '12px',
                        fontWeight: 500,
                        borderRadius: '6px',
                        height: '36px',
                      }}
                    >
                      Edit Certificate
                    </KenButton>
                  </Box>
                </>
                :
                <>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '12px',
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        fontSize: '11px !important',
                      },
                    }}
                  >
                    Upload Certificate
                  </Typography>
                  <TextField
                    sx={{
                      mt: 1.5,
                      borderRadius: '6px',
                      '& .MuiOutlinedInput-root': {
                        height: '36px',
                        borderRadius: '6px',
                        fontSize: '12px',
                      },
                      '& .MuiOutlinedInput-input': {
                        fontSize: '12px',
                      },
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    placeholder="Upload Certificate"
                    value={fileName}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton component="label">
                            <input
                              type="file"
                              hidden
                              accept="application/pdf" // Restrict file picker to allowed formats
                              onChange={handleFileChange}
                            />
                            <FileUploadOutlinedIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  /></>}
            </>

          </Grid>
        </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
          <KenButton
            variant="text"
            className={classes.button}
            sx={{
              mt: 2,
              borderRadius: '8px',
              width: 80,
              backgroundColor: 'transparent !important',
              color: 'black',
              '&:hover': {
                backgroundColor: 'transparent !important',
              },
              '&:active': {
                backgroundColor: 'transparent !important',
              },
              '&:focus': {
                backgroundColor: 'transparent !important',
              },
              '&:focus-visible': {
                backgroundColor: 'transparent !important',
              },
            }}
            onClick={() => handleClose()}
            fullWidth
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                color: '#373A45',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Cancel
            </Typography>
          </KenButton>
          <KenButton
            variant="contained"
            className={classes.button}
            style={{ marginTop: 15, borderRadius: '8px', width: 100, marginLeft: 10, boxShadow: 'none', height: '36px' }}
            onClick={() => postCertificateDetails()}
            fullWidth
            disabled={error}
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                color:"#fff",
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '11px !important',
                },
              }}
            >
              Save
            </Typography>
          </KenButton>
        </Box>
      </Box>

      {/* View Certificate Modal */}
      <Modal open={openViewModal} onClose={handleCloseViewModal}>
        
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
            width: '80%',
            height: '80%',
          }}
        >
          <KenButton
            variant="contained"
            onClick={handleCloseViewModal}
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              borderRadius: '6px',
              marginTop:"-30px",
              float: "right"  
            }}
          >
            Close
          </KenButton>
          <iframe
            src={formData?.certificateUrl}
            title="Certificate"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
          
        </Box>
      </Modal>

      {/* Edit Certificate Modal */}
 <Modal open={openEditModal} onClose={handleCloseEditModal}>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      borderRadius: 2,
      p: { xs: 2, sm: 4 },
      width: { xs: '90%', sm: '60%', md: '40%' }, // Responsive width
      maxHeight: '90vh', // Prevent overflow
      overflowY: 'auto', // Scroll if content is tall
    }}
  >
    <Typography
      sx={{
        fontWeight: 500,
        fontSize: { xs: '10px', sm: '12px' },
        mb: 2,
      }}
    >
      Upload New Certificate
    </Typography>
    <TextField
      sx={{
        mt: 1.5,
        borderRadius: '6px',
        '& .MuiOutlinedInput-root': {
          height: '36px',
          borderRadius: '6px',
          fontSize: { xs: '10px', sm: '12px' },
        },
        '& .MuiOutlinedInput-input': {
          fontSize: { xs: '10px', sm: '12px' },
        },
      }}
      variant="outlined"
      fullWidth
      size="small"
      placeholder="Upload Certificate"
      value={fileName}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton component="label" sx={{ padding: { xs: '4px', sm: '8px' } }}>
              <input
                type="file"
                hidden
                accept="application/pdf"
                onChange={handleFileChange}
              />
              <FileUploadOutlinedIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <KenButton
        variant="text"
        onClick={handleCloseEditModal}
        sx={{
          fontSize: { xs: '10px', sm: '12px' },
          fontWeight: 500,
          color: '#373A45',
          mr: 2,
        }}
      >
        Cancel
      </KenButton>
      <KenButton
        variant="contained"
        onClick={() => {
          handleCloseEditModal();
          postCertificateDetails();
        }}
        sx={{
          fontSize: { xs: '10px', sm: '12px' },
          fontWeight: 500,
          borderRadius: '6px',
          color: "#fff",
        }}
      >
        Save
      </KenButton>
    </Box>
  </Box>
</Modal>

    </div>
  );
};
export default AddCertificateData;
